(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookNodeSearch', HandbookNodeSearch);

    HandbookNodeSearch.$inject = ['$resource'];

    function HandbookNodeSearch($resource) {
        var resourceUrl =  'api/_search/handbook-nodes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
